import withTranslations from './withTranslations';

export default withTranslations;
